import { useEffect } from 'react';
import {
  applyDocumentLang,
  ensureGoogleTranslateMatchesPreference,
  stripGoogleTranslateHash,
} from '../utils/siteLang.js';

const SCRIPT_ID = 'google-translate-element-js';

/**
 * Hidden Google Translate widget — mirrors website/includes/footer.php.
 * Language switching is driven by the header dropdown (cookies + reload).
 */
export default function GoogleTranslate() {
  useEffect(() => {
    applyDocumentLang();
    stripGoogleTranslateHash();
    if (ensureGoogleTranslateMatchesPreference()) return undefined;

    window.googleTranslateElementInit = () => {
      if (!window.google?.translate?.TranslateElement) return;
      // Avoid double-init (React StrictMode / HMR)
      if (document.getElementById('google_translate_element')?.childElementCount) return;
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,fr,ar',
          autoDisplay: false,
        },
        'google_translate_element'
      );
    };

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    } else if (window.google?.translate?.TranslateElement) {
      window.googleTranslateElementInit();
    }

    return () => {
      // Keep the global callback for page lifetime; script stays loaded.
    };
  }, []);

  return <div id="google_translate_element" className="visually-hidden" aria-hidden="true" />;
}
